<template>
  <div>
    <sidebar :activeTab="activeTab"></sidebar>
    <topbar :activeTab="activeTab"></topbar>
    <bottombar :hideBottombar="hideBottombar" :activeTab="activeTab"></bottombar>
  </div>
</template>

<script>
import Sidebar from '@/components/Sidebar';
import Bottombar from '@/components/Bottombar';
import Topbar from '@/components/Topbar';

export default {
  components: {
    Sidebar,
    Bottombar,
    Topbar,
  },
  data() {
    return {
    };
  },
  computed: {
    activeTab() {
      return this.$route.meta.activity;
    },
    hideBottombar() {
      return this.$route.meta.hideBottombar;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue